import { render, staticRenderFns } from "./select-type-label.vue?vue&type=template&id=959a493c"
import script from "./select-type-label.vue?vue&type=script&lang=ts"
export * from "./select-type-label.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports